<template>
    <div class="time_config chartConfig_viewDP">
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">样式</span>
            <el-select v-model="config.style" placeholder="请选择对齐方式"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in styleList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">选择</span>
            <el-checkbox-group v-model="config.timeList" @change="getRender">
                <el-checkbox  label="年"></el-checkbox>
                <el-checkbox  label="月"></el-checkbox>
                <el-checkbox  label="日"></el-checkbox>
                <el-checkbox  label="时" style="margin-left:70px"></el-checkbox>
                <el-checkbox  label="分"></el-checkbox>
                <el-checkbox  label="秒"></el-checkbox>
                <el-checkbox  label="周" style="margin-left:70px"></el-checkbox>
            </el-checkbox-group>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">字体</span>
            <el-select v-model="config.fontFamily" placeholder="请选择字体"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in familyList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til">大小</span>
            <el-input v-model="config.fontSize" @change="getRender" type="number"></el-input>
            <div class="unit">px</div>
        </div>
        <div class="chartDivConfig colViewConfig ">
            <span class="span_til">颜色</span>
            <el-color-picker v-model="config.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">加粗</span>
            <el-select v-model="config.fontWeight" placeholder="请选择粗字号"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in weightList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">对齐</span>
            <el-select v-model="config.align" placeholder="请选择对齐方式"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in alignList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
    /**
     @author xcf
     @date 2020/6/29 14:04 下午
     */
    export default {
        name: 'time_config',
        components: {},
        data() {
            return {
                styleList:[
                    {name:'斜杠：2020/06/02',value:'Slash'},
                    {name:'横杠：2020/06/02',value:'Dash'},
                    {name:'汉字：2020年06月02日',value:'chsChar'},
                    {name:'空格：2020 06 02 ',value:'Space'}
                ],
                familyList:[{name:'黑体',value:'SimHei'},{name:'宋体',value:'SimSun'},{name:'楷体',value:'KaiTi'},{name:'仿宋',value:'FangSong'},{name:'华文中宋',value:'STZhongsong'},{name:'华文行楷',value:'STXingkai'}],
                weightList:[{name:'细',value:'lighter'},{name:'粗',value:'bold'},{name:'更粗',value:'bolder'}],
                alignList:[{name:'靠左对齐',value:'left'},{name:'居中对齐',value:'center'},{name:'靠右对齐',value:'right'}],
            }
        },
        computed: {
            config() {
                return this.$store.state.designer.chart.setting.params;
            },
        },
        methods: {
            getRender() {
                this.$store.dispatch('screenRender');
            },
        },
        mounted() {

        },
        destroyed() {

        }

    }
</script>

<style lang="less">
    .time_config {

    }
</style>
